export default __webpack_public_path__ + "static/media/download-gray.d469528c.svg";